<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="Image" src="images/img01_1-4.png"/></p>
<h1 class="h1"><a id="title"><strong><em>A Primer on</em><br/> D<span class="small">ECISION</span> M<span class="small">AKING</span></strong></a></h1><a id="title">
<p class="subtitle"><strong><em>How Decisions Happen</em></strong></p>
<p class="bauthor"><strong><em>James G. March</em></strong><br/> <em>with the assistance of Chip Heath</em></p>
<p class="publisher"><strong>The Free Press</strong><br/><strong>New York  London  Toronto  Sydney</strong></p>
</a><p class="copyright1"><a id="title"></a><a id="copy">T<span class="small">HE</span> F<span class="small">REE</span> P<span class="small">RESS</span><br/> A Division of Simon &amp; Schuster Inc.<br/> 1230 Avenue of the Americas<br/> New York, NY 10020<br/></a><a class="nounder" href="http://www.SimonandSchuster.com" target="_blank">www.SimonandSchuster.com</a></p>
<p class="copyright">Copyright © 1994 by James G. March</p>
<p class="copyright">All rights reserved,<br/> including the right of reproduction<br/> in whole or in part in any form.</p>
<p class="copyright">T<span class="small">HE</span> F<span class="small">REE</span> P<span class="small">RESS</span> and colophon are trademarks<br/> of Simon &amp; Schuster Inc.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">10</p>
<p class="copyright"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="copyright">March, James G.</p>
<p class="copyright">A primer on decision making: how decisions happen / James G.<br/> March; with the assistance of Chip Heath.</p>
<p class="copyright">  p.    cm</p>
<p class="copyright">Includes bibliographical references and index.</p>
<p class="copyright">ISBN 0-02-920035-0</p>
<p class="copyright">ISBN-13: 978-0-029-20035-3</p>
<p class="copyright">eISBN-13: 978-1-439-10833-8</p>
<p class="list">1. Decision-making.</p>
<p class="list">I. Heath. Chip.</p>
<p class="list">II. Title.</p>
<p class="copyright">HD30.23.M368  1994</p>
<p class="copyright">658.4′03—dc20                              95—4414</p>
<p class="copyright">                              CIP</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001.vue?001c50a4